"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
class LocalStorageDataSource {
    async get(queryOrId) {
        if (queryOrId instanceof __1.Query) {
            if (queryOrId instanceof __1.KeyQuery) {
                return localStorage.getItem(queryOrId.key);
            }
            else {
                throw new __1.QueryNotSupportedError();
            }
        }
        else {
            return localStorage.getItem(queryOrId);
        }
    }
    async getAll(queryOrIds) {
        if (queryOrIds instanceof __1.Query) {
            if (queryOrIds instanceof __1.KeyQuery) {
                let keys = queryOrIds.key.split(',');
                return keys.map((key) => localStorage.getItem(key));
            }
            else {
                throw __1.QueryNotSupportedError;
            }
        }
        else {
            return queryOrIds.map((key) => localStorage.getItem(key));
        }
    }
    async put(value, queryOrId) {
        if (queryOrId instanceof __1.Query) {
            if (queryOrId instanceof __1.KeyQuery) {
                localStorage.setItem(queryOrId.key, value);
                return localStorage.getItem(queryOrId.key);
            }
            else {
                throw __1.QueryNotSupportedError;
            }
        }
        else {
            localStorage.setItem(queryOrId, value);
            return localStorage.getItem(queryOrId);
        }
    }
    async putAll(values, queryOrIds) {
        if (queryOrIds instanceof __1.Query) {
            if (queryOrIds instanceof __1.KeyQuery) {
                let keys = queryOrIds.key.split(',');
                return keys.map((key, index) => {
                    localStorage.setItem(key, values[index]);
                    return localStorage.getItem(key);
                });
            }
            else {
                throw __1.QueryNotSupportedError;
            }
        }
        else {
            return queryOrIds.map((key, index) => {
                localStorage.setItem(key, values[index]);
                return localStorage.getItem(key);
            });
        }
    }
    async delete(queryOrId) {
        if (queryOrId instanceof __1.Query) {
            if (queryOrId instanceof __1.KeyQuery) {
                localStorage.removeItem(queryOrId.key);
                if (localStorage.getItem(queryOrId.key) !== null) {
                    throw new __1.DeleteError();
                }
                return;
            }
            else {
                throw __1.QueryNotSupportedError;
            }
        }
        else {
            localStorage.removeItem(queryOrId);
            if (localStorage.getItem(queryOrId) !== null) {
                throw new __1.DeleteError();
            }
            return;
        }
    }
    async deleteAll(queryOrIds) {
        if (queryOrIds instanceof __1.Query) {
            if (queryOrIds instanceof __1.KeyQuery) {
                let keys = queryOrIds.key.split(',');
                let result = keys.map((key) => {
                    localStorage.removeItem(key);
                    return localStorage.getItem(key) === null;
                });
                if (result.indexOf(false) !== -1) {
                    throw new __1.DeleteError();
                }
                return;
            }
            else {
                throw __1.QueryNotSupportedError;
            }
        }
        else {
            let result = queryOrIds.map((key) => {
                localStorage.removeItem(key);
                return localStorage.getItem(key) === null;
            });
            if (result.indexOf(false) !== -1) {
                throw new __1.DeleteError();
            }
            return;
        }
    }
}
exports.LocalStorageDataSource = LocalStorageDataSource;
